import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState } from 'react';
import ProjectsList from '@rd-web-markets/shared/dist/claim_group/ProjectsList';
import { PROJECT_OVERVIEW_TABLE } from '../constants';
import StartReviewButton from '@rd-web-markets/shared/dist/util/buttons/StartReviewButton';
import changeSetsService from '@rd-web-markets/shared/dist/services/change_sets.service';
import ClientReviewMailerModal from '@rd-web-markets/shared/dist/claim_group/ClientReviewMailerModal';
import { REVIEW_TYPE_CLIENT, REVIEW_TYPE_CONSULTANT } from '@rd-web-markets/shared/dist/util/constants';
import ObjectChangeSetsListWithSnapshots from '@rd-web-markets/shared/dist/technical_review/ObjectChangeSetsListWithSnapshots';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ChangeSetListWithReviewButtonControls from '@rd-web-markets/shared/dist/technical_review/ChangeSetListWithReviewButtonControls';
const TechnicalNarrativesPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'technical_narratives',
  ClaimGroupChildPage: function (_ref) {
    let {
      accountType,
      handleToaster,
      claimGroup,
      setClaimGroup,
      resetClaimGroup,
      t,
      pageIsLoading,
      setPageIsLoading
    } = _ref;
    const [showClientReviewMailerModal, setShowClientReviewMailerModal] = useState(false);
    const [projectForClientReview, setProjectForClientReview] = useState(null);
    const createChangeSet = changeSetsService.useCreateChangeSet(resetClaimGroup, setPageIsLoading);
    const finalizeChangeSet = changeSetsService.useFinalizeChangeSet(resetClaimGroup, setPageIsLoading);
    const approveChangeSet = changeSetsService.useApproveChangeSet(resetClaimGroup, setPageIsLoading);
    const rejectChangeSet = changeSetsService.useRejectChangeSet(resetClaimGroup, setPageIsLoading);
    const createChangeSetForClient = changeSetsService.useCreateChangeSetForClient(resetClaimGroup, setPageIsLoading, handleToaster);
    const customColumns = ['bussiness_units', 'project_name', 'Reviewer Name', 'Review Type', 'Review State', project => /*#__PURE__*/React.createElement(StartReviewButton, {
      text: t('set_ready_for_manager_review'),
      loading: pageIsLoading,
      reviewedObject: project,
      reviewedObjectClass: 'ClaimProjectReport',
      reviewType: REVIEW_TYPE_CONSULTANT,
      onClick: () => createChangeSet(project, 'ClaimProjectReport', REVIEW_TYPE_CONSULTANT)
    }), project => /*#__PURE__*/React.createElement(StartReviewButton, {
      text: t('set_ready_for_client_review'),
      loading: pageIsLoading,
      reviewedObject: project,
      reviewedObjectClass: 'ClaimProjectReport',
      reviewType: REVIEW_TYPE_CLIENT,
      onClick: () => {
        setProjectForClientReview(project);
        setShowClientReviewMailerModal(true);
      }
    }), report => !!claimGroup.active_change_set ? t('another_review_was_started_please_complete_it_first') : /*#__PURE__*/React.createElement(Link, {
      as: Button,
      to: `/${accountType}/claim_groups/${claimGroup.id}/technical_narratives/${report.id}`
    }, t('view_technical_narrative_details')), 'toggle_expand'];
    const customHeaders = [PROJECT_OVERVIEW_TABLE.headers.find(h => h.text === 'business_unit'), PROJECT_OVERVIEW_TABLE.headers.find(h => h.text === 'name'), {
      text: t('reviewer_name')
    }, {
      text: t('review_type')
    }, {
      text: t('review_state')
    }, {
      text: ''
    }, {
      text: ''
    }, {
      text: ''
    }, {
      text: ''
    }];
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProjectsList, {
      customHeaders: customHeaders,
      customColumns: customColumns,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup,
      groupProjects: false,
      renderExpandedRowContent: row => {
        const {
          project
        } = row.data;
        return /*#__PURE__*/React.createElement(ChangeSetListWithReviewButtonControls, {
          canShowStartTrackingChangesButton: false,
          reviewedObject: project,
          reviewedObjectClass: 'ClaimProjectReport',
          snapshotsContainingObject: project,
          reviewType: project.active_change_set?.review_type,
          snapshotsResetDataFn: () => {
            console.log('reset snapshots');
          },
          showSnapshotsForAllReviewTypes: true,
          isLoading: pageIsLoading,
          claimGroup: claimGroup
          // createChangeSet={createChangeSet}
          ,
          finalizeChangeSet: finalizeChangeSet,
          approveChangeSet: approveChangeSet,
          rejectChangeSet: rejectChangeSet
        });
      },
      onToggleExpandProjectRow: project => {
        project.expanded = !project.expanded;
      }
    }), showClientReviewMailerModal && projectForClientReview && /*#__PURE__*/React.createElement(ClientReviewMailerModal, {
      setClaimGroup: setClaimGroup,
      claimGroup: claimGroup,
      show: showClientReviewMailerModal,
      setModalShow: setShowClientReviewMailerModal,
      loading: pageIsLoading,
      createChangeSetForClient: createChangeSetForClient,
      reviewType: REVIEW_TYPE_CLIENT,
      reviewedObjectClass: 'ClaimProjectReport',
      reviewedObject: projectForClientReview
    }));
  }
});
export default TechnicalNarrativesPage;